import { useState } from 'react'
import { Box, Grid2 } from '@mui/material'
import { useAdminTrainerList } from '../../assets/api/useAdminApi'
import { Field } from 'formik'
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField'
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate'
import { useTrainerColumnsWithDialog } from '../../shared/utils/getTrainerColumnsWithDialog'
import { LocationFilterFields } from '../../shared/components/LocationFilterFields'
const TrainerList = () => {
  const { trainerColumns, dialogJSX, viewTrainerCourse } = useTrainerColumnsWithDialog();
  const [filters, setFilters] = useState({});
  const { data: trainerlist, isLoading } = useAdminTrainerList(filters)
  const StatusOption = [
    {
      id: 1,
      label: "Assigned",
      value: "assigned",
    },
    {
      id: 0,
      label: "Unassigned",
      value: "unassigned",
    }
  ]
  return (
    <Box>
      <TableFilterTemplate
        title="Trainer List"
        columns={trainerColumns}
        rowsData={trainerlist?.data || []}
        isLoading={isLoading}
        filterInitialValues={filters}
        filterReset={() => setFilters({})}
        onApplyFilters={(f) => setFilters(f)}
        dataGridProps={{
          onRowClick: (params) => viewTrainerCourse(params.row)
        }}
        renderFilterFields={() => (
          <>
            <Grid2 children size={12}>
              <Field
                name="assignment_status"
                component={IdAutoCompleteField}
                options={StatusOption}
                label="Status"
                isRequired={true}
              />
            </Grid2>
            <LocationFilterFields
              countryField="country_name"
              stateField="state"
              cityField="city"
              isStoredId={false}
            />
          </>

        )}
      />
      {dialogJSX}
    </Box>
  )
}

export default TrainerList